'use client'

import { initAdjust } from 'shared/metrics/adjust/adjust'

import { useEffect } from 'react'

export function YaMetrika() {
  useEffect(() => {
    const timer = setTimeout(() => {
      ;(function (
        m: Record<string, any>, // window
        e: Document,
        t: string,
        r: string,
        i: string,
        k?: HTMLScriptElement,
        a?: HTMLScriptElement | null,
      ): void {
        m[i] =
          m[i] ||
          function (...args: any[]) {
            ;(m[i].a = m[i].a || []).push(args)
          }

        m[i].l = Date.now()

        for (let j = 0; j < e.scripts.length; j++) {
          if (e.scripts[j].src === r) {
            return
          }
        }

        k = e.createElement(t) as HTMLScriptElement
        a = e.getElementsByTagName(t)[0] as HTMLScriptElement | null

        if (a?.parentNode) {
          k.async = true
          k.src = r
          a.parentNode.insertBefore(k, a)
        }
      })(
        window,
        document,
        'script',
        'https://mc.yandex.ru/metrika/tag.js',
        'ym',
      )

      // Инициализация
      if (typeof window !== 'undefined' && typeof window.ym === 'function') {
        //@ts-ignore
        window.ym(96920986, 'init', {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
          ecommerce: 'dataLayer',
        })
      }
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  return null
}

export function Adjust() {
  useEffect(() => {
    initAdjust()
  }, [])

  return null
}
